export default __webpack_public_path__ + "images/logoLuxeBotanics.2fa3a437dbcc0f7fe3334d62ae60c72d.svg"